import React, { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";

export default function Payment() {
  const location = useLocation();
  const user = location.state?.user || null;
  const errorMessage = location.state?.errorMessage || null;

  // Cart State
  const [cart, setCart] = useState(location.state?.cart || []);

  // Payment State
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [isLoading, setIsLoading] = useState(false);

  // Derived Totals
  const totalItems = useMemo(
    () => cart.reduce((sum, item) => sum + (item.quantity || 1), 0),
    [cart]
  );

  const totalAmount = useMemo(
    () =>
      cart.reduce(
        (sum, item) => sum + (item.mrp * (item.quantity || 1)),
        0
      ),
    [cart]
  );

  // Handlers
  const handleConfirmPayment = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      console.log("Payment confirmed");
    }, 1500);
  };

  const toggleCartItem = (product) => {
    setCart((prevCart) => {
      const exists = prevCart.some((item) => item.name === product.name);
      return exists
        ? prevCart.filter((item) => item.name !== product.name)
        : [...prevCart, { ...product, quantity: 1 }];
    });
  };

  const updateQuantity = (productName, change) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.name === productName
          ? { ...item, quantity: Math.max(1, (item.quantity || 1) + change) }
          : item
      )
    );
  };

  return (
    <div className="h-full flex flex-col overflow-hidden bg-gradient-to-tr from-blue-50 via-indigo-50 to-teal-50 p-3 sm:p-4">
      {/* Header */}
      <Header
        cart={cart}
        user={user}
        showSearch={false}
        showCart={true}
        addToCart={toggleCartItem}
      />

      {/* Main Content */}
      <section className="relative mt-4 rounded-xl overflow-hidden shadow-md border border-blue-200 flex flex-col flex-1 min-h-0">
        <div className="px-5 py-3 bg-gradient-to-r from-indigo-100 via-blue-100 to-teal-100 border-b border-blue-200 flex-shrink-0">
          <h2 className="text-base font-bold text-blue-800">&#x1F4B3; Payment</h2>
        </div>
        <div className="flex-1 flex flex-col items-center justify-center p-6">
        {errorMessage ? (
          <div className="bg-red-100 text-red-700 border border-red-300 px-6 py-4 rounded-lg shadow-md max-w-md text-center">
            <p className="text-lg font-semibold">⚠️ Payment Error</p>
            <p className="mt-2">{errorMessage}</p>
          </div>
        ) : (
          <div className="w-full max-w-lg bg-white rounded-xl shadow-lg border border-blue-100 p-6 space-y-6">
            <h2 className="text-center text-2xl font-bold text-blue-800">
              💳 Payment Page
            </h2>

            {/* Cart Summary */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-lg">
                <strong>Total Items:</strong> {totalItems}
              </p>
              <p className="text-lg">
                <strong>Total Amount:</strong>{" "}
                <span className="text-green-600 font-semibold">
                  ₹{totalAmount.toFixed(2)}
                </span>
              </p>
            </div>

            {/* Payment Method */}
            <div>
              <h3 className="text-lg font-semibold mb-2">
                Select Payment Method
              </h3>
              <select
                className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                onChange={(e) => setPaymentMethod(e.target.value)}
                value={paymentMethod}
              >
                <option value="card">💳 Credit/Debit Card</option>
                <option value="upi">📱 UPI</option>
                <option value="cash">💵 Cash</option>
              </select>
            </div>

            {/* Confirm Payment */}
            <button
              onClick={handleConfirmPayment}
              disabled={isLoading}
              className={`w-full py-3 rounded-lg text-white font-semibold shadow-md transition-all ${
                isLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {isLoading ? "Processing..." : "Confirm Payment"}
            </button>
          </div>
        )}
        </div>
      </section>
    </div>
  );
}
